module.exports = __webpack_public_path__ + "img/very-main-mob.026db584.jpg";